import React, {useEffect, useRef, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {maxLength} from "../../../utils/patterns";
import {SearchIcon} from "../../../../assets/icons/defaultIcons";
import "./search-field.scss";
import {useNavigate} from "react-router";
import {Input} from "antd";
import {useUser} from "../../../providers/UserContext";
import {IoMdClose} from "react-icons/io";

export default function SearchField({ heading, searchData }) {
  const navigate = useNavigate();
  const { VaultSearch ,setVaultSearch } = useUser();
  const [showTags, setShowTags] = useState(false);
  const searchFieldRef = useRef(null);
  const [wasFilled, setWasFilled] = useState(false);

  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
    watch,
    clearErrors,
  } = useForm({
    mode: "onChange",
  });
  const onSubmit = async (data) => {
    setVaultSearch(data.search);
  };

  const fieldValue = watch("search");

  useEffect(() => {
    setValue("search", "");
  }, []);

  // Handling the Enter key press
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent the default enter key behavior
      handleSubmit(onSubmit)(); // Manually trigger form submission
      setShowTags(false);
    }
  };

  // Effect to monitor changes in the 'search' field
  useEffect(() => {
    // Check if the field went from being filled to empty
    if (wasFilled && fieldValue === "") {
      setVaultSearch("");
      // Perform any action you want here
    }
    // Update wasFilled state based on current fieldValue
    setWasFilled(fieldValue !== "");
  }, [fieldValue]); // Re-run effect when fieldValue changes

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
          searchFieldRef.current &&
          !searchFieldRef.current.contains(event.target)
      ) {
        setShowTags(false); // Set showTags to false if clicked outside of the component
      }
    };

    // Add event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Remove event listener when the component unmounts
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function clickTags(item) {
    setVaultSearch(item);
    setValue("search", item);
  }

  return (
      <div className={"search-field"}>
        <div className={""}>
          <Controller
              name="search"
              defaultValue={""}
              control={control}
              rules={{ maxLength: maxLength(500) }}
              render={({ field: { name, ...field } }) => (
                  <div className={"text-field"}>
                    <Input
                        {...field}
                        placeholder={"Search"}
                        status={errors.search && "error"}
                        // suffix={options.suffix}
                        prefix={<SearchIcon />}
                        type={"text"}
                        // disabled={options.disabled}
                        // defaultValue={options.defaultValue}
                        onKeyDown={(e) => {
                          handleKeyDown(e);
                        }}
                        onClick={() => {
                          setShowTags(true);
                        }}
                    />
                  </div>
              )}
          />
        </div>

        {showTags && (
            <div className={"recent-search"} ref={searchFieldRef}>
              <h5>
                {heading}{" "}
                <span
                    onClick={() => {
                      setShowTags(false);
                    }}
                >
              <IoMdClose />
            </span>
              </h5>
              <div className={"recent-search-area"}>
                {searchData && (
                    <ul>
                      {searchData?.map((item, index) => {
                        return (
                            <li key={index}>
                              <div className={"search-box"}>
                                <div className={"content"}>
                                  <p
                                      onClick={() => {
                                        clickTags(item.name);
                                      }}
                                  >
                                    {item.name}
                                  </p>
                                  {item.des && <span>{item.des}</span>}
                                </div>
                                {/*<div className={'close'} onClick={()=>{setValue('search', '')}}>*/}
                                {/*    <MdOutlineClose />*/}
                                {/*</div>*/}
                              </div>
                            </li>
                        );
                      })}
                    </ul>
                )}
              </div>
            </div>
        )}
      </div>
  );
}
